import { Feature } from "./feature"

export class PlanItem {
    bankFee: any
    constructor() {
    }

    id: string
    featureId: string
    planId: string
    planSeoName: string
    planName: string
    storeId: string
    storeUrl: string
    referenceId: string
    referenceType: any
    monetizationType: any
    period: any
    price: number
    percentage: number
    name: string
    description: string
    notes: string
    priceType: number
    mrr: number
    features: Array<Feature>
    startDate: any
    endDate: any
    lastPaidDate: Date
    infinite: boolean
    active: boolean
}

